<mat-card class="integrations-card">
  <div class="card-content">
    <div class="info-section">
      <mat-icon class="sync-icon" aria-hidden="true">sync_alt</mat-icon>
      <div class="text-block">
        <p class="title">{{ 'billing.integrationsUpsell.title' | translate }}</p>
        <p class="description">{{ 'billing.integrationsUpsell.description' | translate }}</p>
      </div>
      <div class="logos-row">
        <div class="logo-circle" *ngFor="let logo of logos">
          <img [src]="logo.src" [alt]="logo.alt" class="integration-logo" />
        </div>
      </div>
    </div>
    <button mat-flat-button class="explore-button" (click)="navigateToIntegrations()">
      {{ 'billing.integrationsUpsell.cta' | translate }}
    </button>
  </div>
</mat-card>
